import { render, staticRenderFns } from "./ExtCustomerPhoenix.vue?vue&type=template&id=8d40743e&scoped=true&"
import script from "./ExtCustomerPhoenix.vue?vue&type=script&lang=js&"
export * from "./ExtCustomerPhoenix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d40743e",
  null
  
)

export default component.exports